export function validateQuantity(value: any): boolean {
    if (value && Number(value)) {
        const QUANTITY_REGEXP = /^[0-9]+$/;
        return QUANTITY_REGEXP.test(value.toString());
    } 
    return false;
}